import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AvailabilityComponent } from '@app/shared/components/availability/availability-text.component';
import { MenuOverlayComponent } from '@app/shared/components/menu-overlay/menu-overlay';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'customizer-item',
	templateUrl: 'customizer-item.html',
	styleUrls: ['./customizer-item.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CommonModule, AvailabilityComponent, TranslatePipe, MenuOverlayComponent]
})
export class CustomizerItemComponent implements OnChanges {

	@Input() item: any;
	@Input() name: string = 'name';
	@Input() image: (item: any) => string;
	@Input() description: string;
	@Input() selected: boolean;
	@Input() discontinued: string;
	@Input() editMode: boolean;
	@Input() isModelSize: boolean;
	@Input() isGemstone: boolean;
	@Input() variantOrModelIsNew: boolean = false;
	@Input() noneChoiceTranslation: string;
	@Input() noneChoiceImage: string | null;

	public showOverlay: boolean;

	constructor() { }

	ngOnChanges(changes: SimpleChanges) {

		if (changes['selected'] && !changes['selected'].firstChange && this.editMode) {
			this.showOverlay = changes['selected'].currentValue;
			new Promise(resolve => setTimeout(resolve, 2500)).then(x => {
				this.showOverlay = false;
			});
		}
	}

	replaceHash(input: string): string {
		if (!input) {
			return '';
		}

		if (input.indexOf('#') > -1) {
			return '□';
		} else if (input.indexOf('¤') > -1) {
			return '○';
		}
		return '';
	}

}
